/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber4Small = createReactComponent("outline", "number-4-small", "IconNumber4Small", [["path", { "d": "M10 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M14 8v8", "key": "svg-1" }]]);

export { IconNumber4Small as default };
//# sourceMappingURL=IconNumber4Small.mjs.map
